import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/** Ancienne route `/fanzone/:id` → onglet Fan zone de la fiche match. */
export default function FanZonePage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/" replace />;
  return <Navigate to={`/match/${id}?tab=fanzone`} replace />;
}
